export default ({ axios, mapQueryString }) => ({
    index: (query = {}) => axios.get(`/sectors${mapQueryString(query)}`),
    show: (id = {}) => axios.get(`/sectors/${id}`),
    store: (data) => axios.post(`/sectors`, data),
    update: (id, data) => axios.patch(`/sectors/${id}`, data),
    delete: (id) => axios.delete(`/sectors/${id}`),
})